import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    marginTop: 61
  },
  tokeExpiredWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    marginBottom: 30
  },
  inputIndent: {
    marginTop: 24
  },
  button: {
    width: '100%',
    marginTop: 36,
    marginBottom: theme.spacing(3)
  },
  backLogin: {
    marginTop: '24px'
  }
}));

export default useStyles;
